export default {
    computed: {
        lisawebBaseUrl() {
            return process.env.VUE_APP_LISAWEB_SWITCH_URL;
        },
        showLisawebSwitch() {
            return !!this.lisawebBaseUrl;
        }
    },
    methods: {
        /**
         * Redirects the user to the agency-specific Lisaweb URL.
         * @param {string} agencyCode - The code to inject into the URL.
         */
        switchLisaweb(agencyCode) {
            if (!this.showLisawebSwitch || !agencyCode) {
                console.warn("Lisaweb switch triggered but URL or Agency Code is missing.");
                return;
            }

            const finalUrl = this.lisawebBaseUrl.replace(':agency_code', agencyCode.toLowerCase());

            window.open(finalUrl, "_self");
        }
    }
};